import { Fragment } from "react";
import clsx from "clsx";
import { TextBadge, SectionTitle } from "components/atoms/Text";
import { questionList } from "data/questionList";
import DisclosureItem from "./DisclosureItem";

const PopularQuestions = () => {
    return (
        <Fragment>
            <section className={clsx(
                "w-full max-w-[1440px] mx-auto bg-neutral-10",
                "phone:py-12 py-[88px] tablet:py-16 px-6 tablet:px-8 desktop:px-[120px]"
            )}>
                <div className="max-w-full md:max-w-[584px] mx-auto text-center">
                    <TextBadge>FAQ</TextBadge>
                    <SectionTitle classNames="!pb-0">Popular Questions</SectionTitle>
                </div>
                <div className="w-full flex flex-col max-w-full md:max-w-[790px] mx-auto phone:mt-8 mt-10">
                    {questionList.map((item) => (
                        <DisclosureItem key={item.id} question={item.question} answer={item.answer} />
                    ))}
                </div>
            </section>
        </Fragment>
    );
};

export default PopularQuestions;